<template>
  <div>
    <b-btn
      class="composition-item-btn"
      variant="light"
      @click="toggleItemCollapse"
    >
      <b-checkbox
        v-model="compositionVisible"
        @change="layerVisibleChanged"
        class="float-left inline-custom-checkbox"
        :disabled="
          compositionsBranch.objType === 'layer'
            ? !compositionsBranch.valid
            : false
        "
        :indeterminate="checkboxState === 'indeterminate'"
        @click.stop="toggleItemCollapse"
      ></b-checkbox>
      <span
        style="word-break: break-word"
        v-if="
          compositionsBranch.objType === 'layer'
            ? !compositionsBranch.valid
            : false
        "
        class="cursor-pointer mr-1 float-left"
        v-b-tooltip="{
          title:
            'Nie można włączyć warstwy, adres warstwy lub typ warstwy jest nieprawidłowy.',
          boundary: 'window',
          trigger: 'hover'
        }"
      >
        <span
          style="word-break: break-word"
          class="oi oi-warning text-primary"
          aria-hidden="true"
        ></span>
      </span>
      <span class="float-left">
        {{
          compositionsBranch.objType !== 'layer'
            ? compositionsBranch.name
            : compositionsBranch.title || compositionsBranch.name
        }}
      </span>
      <div v-if="compositionsBranch.objType !== 'layer'">
        <icon
          class="float-right ml-1"
          v-show="compositionsBranch.expandWidget"
          name="caret-up"
        ></icon>
        <icon
          class="float-right ml-1"
          v-show="!compositionsBranch.expandWidget"
          name="caret-down"
        ></icon>
      </div>
    </b-btn>
    <b-collapse
      class="collapsible-widget-body"
      v-model="compositionsBranch.expandWidget"
    >
      <CompositionsBranch
        v-for="childBranch in compositionsBranch.compositions"
        :key="childBranch.id"
        :compositionsBranch="childBranch"
        v-model="childBranch.visible"
      />
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SET_LAYER_VISIBILITY } from '../store/mutations.type';
import { COMPOSITIONS_SHOW } from '../store/actions.type';

export default {
  name: 'CompositionsBranch',
  props: {
    compositionsBranch: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters([
      'layers',
      'systemLayers',
      'mvtLayers',
      'pwidLayers',
      'archiveLayers',
      'compositionGroupLayers'
    ]),
    compositionVisible: {
      get() {
        return this.checkboxState == 'indeterminate'
          ? false
          : this.checkboxState;
      },
      set(value) {
        if (value || this.checkboxState != 'indeterminate') {
          this.setTopObjectVisibility(this.compositionsBranch, value);
        }
      }
    },
    checkboxState() {
      const children = this.compositionsBranch.compositions;

      if (!children || children.length === 0) {
        return this.compositionsBranch.visible;
      }

      const validChildren = children.filter(
        child => !(child.objType === 'layer' && !child.valid)
      );
      const validChildrenCount = validChildren.length;
      const selectedCount = validChildren.filter(child => child.visible).length;
      const unselectedCount = validChildren.length - selectedCount;
      const indeterminateCount = validChildren.filter(
        child => child.indeterminate
      ).length;

      if (selectedCount === validChildrenCount) {
        return true;
      }
      if (unselectedCount === validChildrenCount) {
        if (indeterminateCount) {
          return 'indeterminate';
        } else {
          return false;
        }
      } else {
        return 'indeterminate';
      }
    }
  },
  methods: {
    calculateVisibility(compositions) {
      if (
        !compositions.compositions ||
        (compositions.compositions && compositions.compositions.length === 0)
      ) {
        return compositions.visible;
      }
      return compositions.compositions.every(composition => {
        if (composition.objType == 'layer' && !composition.valid) {
          return true;
        } else {
          return this.calculateVisibility(composition);
        }
      });
    },
    setTopObjectVisibility(composition, value) {
      composition.visible = value;
      this.updateChildrenVisibility(composition, value);
    },

    updateChildrenVisibility(composition, value) {
      if (composition.compositions && composition.compositions.length) {
        composition.compositions.forEach(child => {
          if (child.objType !== 'layer' || child.valid) {
            child.visible = value;
            // this.updateChildrenVisibility(child, value); // Recursively update grandchildren
          }
        });
      }
    },
    checkIfAddressIsCorrect(layer) {
      return !(
        layer.objType === 'layer' &&
        (!layer.address || !layer.address.trim())
      );
    },
    toggleItemCollapse() {
      if (
        this.compositionsBranch.compositions &&
        this.compositionsBranch.compositions.length
      ) {
        this.compositionsBranch.expandWidget = !this.compositionsBranch
          .expandWidget;
      }
    },
    async layerVisibleChanged(value) {
      // if (value) {
      this.hideVisibleLayers();
      await this.$store.dispatch(COMPOSITIONS_SHOW, {
        composition: this.compositionsBranch
      });
      // }
      // this.updateChildrensCheckbox(value);
    },
    updateChildrensCheckbox(value) {
      if (this.compositionsBranch.objType === 'layer') {
      } else if (this.compositionsBranch.compositions) {
        this.recursiveUpdateVisible(
          this.compositionsBranch.compositions,
          value
        );
      }
    },
    recursiveUpdateVisible(compositions, value) {
      compositions.forEach(composition => {
        if (this.checkIfAddressIsCorrect(composition)) {
          this.$set(composition, 'visible', value);
        }

        if (composition.compositions) {
          this.recursiveUpdateVisible(composition.compositions, value);
        }
      });
    },
    async hideVisibleLayers() {
      this.systemLayers.forEach(layer => {
        this.$store.commit(SET_LAYER_VISIBILITY, {
          layerId: layer.id,
          visible: false
        });
      });
      this.pwidLayers.forEach(layer => {
        this.$store.commit(SET_LAYER_VISIBILITY, {
          layerId: layer.id,
          visible: false
        });
      });
      this.archiveLayers.forEach(layer => {
        this.$store.commit(SET_LAYER_VISIBILITY, {
          layerId: layer.id,
          visible: false
        });
      });
      this.mvtLayers.forEach(layer => {
        this.$store.commit(SET_LAYER_VISIBILITY, {
          layerId: layer.id,
          visible: false
        });
      });

      // window.console.log(this.compositionGroupLayers);
      // this.compositionGroupLayers.forEach(layer => {
      //   this.$store.commit(SET_LAYER_VISIBILITY, {
      //     layerId: layer.id,
      //     visible: false
      //   });
      // });
    }
  },
  watch: {
    compositionVisible: {
      handler(newValue) {
        this.compositionsBranch.visible = newValue;
      }
    },
    checkboxState: {
      handler(newValue) {
        this.compositionsBranch.indeterminate = newValue;
      }
    }
  }
};
</script>

<style scoped>
.collapsible-widget-body {
  margin-left: 10px;
}
</style>
